import { render } from "./AddObjectModal.vue?vue&type=template&id=c09ccea4"
import script from "./AddObjectModal.vue?vue&type=script&lang=js"
export * from "./AddObjectModal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AddObjectModal.vue?vue&type=style&index=1&id=c09ccea4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__